import _pick from 'lodash/pick';
import _size from 'lodash/size';

/**
 * convertObjectToQueryString - Converts a given object with matching keys (keysArray) as a query formatted string.
 *
 * @param  {object} object - object containing N amount of properties to be matched by the keysArray
 * @param  {array} keysArray - array containing keys that should match the passed object
 * @return {string} - returns a properly formatted query string (i.e. id=123&lang=pt...); defaults to an empty string
 */
export default function convertObjectToQueryString(object, keysArray) {
    if (!object || !keysArray || Array.isArray(keysArray) === false || keysArray.length < 1) {
        return '';
    }

    let convertedString = '';
    const matchingObject = _pick(object, keysArray);

    if (matchingObject) {
        let currentObjectCount = 0;
        let lengthOfMatchingObject = _size(matchingObject);

        Object.keys(matchingObject).forEach(key => {
            let value = matchingObject[key];
            currentObjectCount++;
            convertedString += `${key}=${value}`;

            if (currentObjectCount !== lengthOfMatchingObject) {
              convertedString += '&';
            }
        });
    }

  return convertedString;
}



// WEBPACK FOOTER //
// ./app/lib/format/convertObjectToQueryString.js